import type { ReactNode } from "react";
import classNames from "classnames/dedupe";

interface StickyFooterProps {
  hidden?: boolean;
  className?: string;
  children?: ReactNode;
}

export const StickyFooter = ({
  hidden = false,
  className = "",
  children,
}: StickyFooterProps) => {
  const classes = classNames("sticky__footer", className, {
    "sticky__footer--hidden": hidden,
  });

  return (
    <div className={classes} data-testid="sticky__footer" aria-hidden={hidden}>
      <div className="sticky__content">{children}</div>
    </div>
  );
};
